export const MATCH_HUB_TEAM_FACTS_COPY = {
  TITLE: 'Team Comparison',
  EMPTY: 'No team facts available yet.',
  NOTES_TITLE: 'Did You Know?',
} as const;

export const MATCH_HUB_TEAM_FACTS_TEST_IDS = {
  card: 'match-hub-team-facts',
  notes: 'match-hub-team-fact-notes',
} as const;
